/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Area from "../../components/Area";

const AdminArea = (props) => {
    return (
        <Area moduleType={'Admin'}  {...props}/>
    )
}

export default AdminArea